export default __webpack_public_path__ + "static/media/google-logo.3bdbda8c.svg";